module.exports = __webpack_public_path__ + "static/media/attack-number-1.11e3d222.png";